import {ProductInfo} from "src/model/ProductMatch";
import {AdditionalInfo} from "src/model/AdditionalInfo";
import {isLoginMode} from "src/config/Config";
import QueryProductInfo from "src/model/QueryProduct";

export default class ProductDataValidator {

    public static isProductValid = (product?: ProductInfo): boolean => {
        if (!product) {
            return false;
        }
        return !isLoginMode() || ProductDataValidator.isDimensionAndWeightValid(product.height, product.width, product.length, product.weight,
            product.dimensionUnit, product.weightUnit);
    }

    public static isProductAndAdditionalInfoValid = (product?: ProductInfo, additionalInfo?: AdditionalInfo): boolean => {
        if (!product) {
            return false;
        }
        let hasDWInProductInfo = ProductDataValidator.isDimensionAndWeightValid(product.height, product.width, product.length, product.weight,
            product.dimensionUnit, product.weightUnit);
        if (hasDWInProductInfo) {
            return true;
        }

        if (!additionalInfo) {
            return false;
        }
        let hasDWInAdditionalInfo = ProductDataValidator.isDimensionAndWeightValid(additionalInfo.height, additionalInfo.width,
            additionalInfo.length, additionalInfo.weight, additionalInfo.dimensionUnit, additionalInfo.weightUnit);
        return hasDWInAdditionalInfo;
    }

    public static isQueryProductDimensionValid = (queryProduct?: QueryProductInfo): boolean => {
        if (!queryProduct) {
            return false;
        }
        return ProductDataValidator.isDimensionAndWeightValid(Number(queryProduct.packageHeight),
            Number(queryProduct.packageWidth), Number(queryProduct.packageLength), Number(queryProduct.packageWeight),
            queryProduct.dimensionUnit, queryProduct.weightUnit);
    }

    public static isDimensionAndWeightValid = (height?: number, width?: number, length?: number, weight?: number,
                                               dimensionUnit?: string, weightUnit?: string): boolean => {
        return !!weightUnit && !!dimensionUnit && length! > 0 && width! > 0 && height! > 0 && weight! > 0;
    }
}
